import { connect } from 'react-redux';

import {
  subscribeToVisibleBoardgames,
  unsubscribeToVisibleBoardgames,
  reserveBoardgame,
  getBackBoardgame,
  getBackAllBoardgames,
} from '../actions/boardgames';

import { getCategories } from '../actions/categories';

import { getSecondHandBoardgames } from '../actions/secondHandBoardgames';

import {
  visibleBoardgamesSelector,
  maxNumberOfPlayersSelector,
  loadingSelector,
  getBackAllBoardgamesButtonEnabledSelector,
} from '../reducers/boardgames';

import { categoriesSelector } from '../reducers/categories';

import BoardgamesListPageComponent from '../components/BoardgamesListPage';

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    boardgames: visibleBoardgamesSelector(state),
    maxNumberOfPlayers: maxNumberOfPlayersSelector(state),
    loading: loadingSelector(state),
    isGetBackAllBoardgamesButtonEnabled: getBackAllBoardgamesButtonEnabledSelector(state),
    categories: categoriesSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getVisibleBoardgames: (orderBy) => dispatch(subscribeToVisibleBoardgames(orderBy)),
    unsubscribeToVisibleBoardgames: () => dispatch(unsubscribeToVisibleBoardgames()),
    getCategories: () => dispatch(getCategories()),
    reserveBoardgame: (id) => dispatch(reserveBoardgame(id)),
    getBackBoardgame: (id) => dispatch(getBackBoardgame(id)),
    getBackAllBoardgames: (ids) => dispatch(getBackAllBoardgames(ids)),
    getSecondHandBoardgames: () => dispatch(getSecondHandBoardgames()),
  };
};

const BoardgamesListPage = connect(mapStateToProps, mapDispatchToProps)(BoardgamesListPageComponent);

export default BoardgamesListPage;

